export default __webpack_public_path__ + "static/media/news-fallback.adc64328.jpg";